import "./App.css";
import Experience from "./Experience";
import { featuresContext as features } from "./Experience/features";
import noiseTexture from "./assets/noise_texture.png";
import { useState } from "react";

// const HelperText = ({ isPlaying }) => {
//   return (
//     <div className={`music-instructions ${isPlaying ? null : "is-active"}`}>
//       Click orb to activate music
//     </div>
//   );
// };

function App() {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <div
      className="App"
      style={{ background: `hsl(${features.baseHue},15%,2%)` }}
    >
      <Experience
        features={features}
        isPlaying={isPlaying}
        setIsPlaying={setIsPlaying}
      />
      <div
        className="noise"
        style={{
          backgroundImage: `url(${noiseTexture})`,
          opacity: features.noise / 3,
        }}
      />
      <div className="vignette" />
      {/* <HelperText isPlaying={isPlaying} /> */}
    </div>
  );
}

export default App;
